export const selectMenu = {
    slots: {
        placeholder: 'text-muted',
    },
    variants: {
        size: {
            md: {
                base: 'p-3.5',
            },
        },
    },
}
